import { useTranslation } from "react-i18next";

export default function FormatDate(timestamp) {

    const [t] = useTranslation(["global"])

    const date = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isToday = date.toDateString() === today.toDateString();
    const isYesterday = date.toDateString() === yesterday.toDateString();

    const time = date.toLocaleTimeString('it-IT', {
        hour: '2-digit',
        minute: '2-digit',
    });

    if (isToday) {
        return `${t("time.today")} - ${time}`;
    } else if (isYesterday) {
        return `${t("time.yesterday")} - ${time}`;
    } else {
        return new Intl.DateTimeFormat('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).format(date) + ` alle ${time}`;
    }
}